import 'admin-lte'
import 'unpoly'
import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import $ from 'jquery'

import 'admin-lte'
import '@popperjs/core'
import * as bootstrap from 'bootstrap'

// Keep library side-effects/imports consistent
import L from 'leaflet'

import 'leaflet/dist/leaflet.css'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import 'leaflet-routing-machine'


// App modules
import configureUnpoly from './config/unpoly-config'
import registerUICompilers from './components/ui-compilers'
import registerToastCompiler from './components/toast'
import registerCardWidgetCompiler from './components/card-widget'
import ensureLeafletMap from './features/map/leaflet-map'
import registerDrivingDashboard from './features/dashboard/driving-dashboard'
import registerDrivingReportDetail from './features/dashboard/driving-report-detail'
import { initMap } from './features/map/navitime-map'
import { toTime } from './utils/time-utils'
import { tripDataAlpine } from './features/timeline/trip-data-alpine'

// Alpine / Bootstrap globals (as before)
window.Alpine = Alpine
window.bootstrap = bootstrap
Alpine.plugin(persist)
Alpine.start()

// Unpoly configuration
configureUnpoly()

// Globals preserved
window.navitimeConfig = { apiUrl: '', customerId: '', signature: '', requestCode: '', toBeLoadedFrom: '' }
window.markers = []
window.routePath = []
window.infoWindows = []

// Expose selected utilities needed by inline handlers (popover templates use toTime)
window.toTime = toTime

// Map compiler (initialize Navitime + Leaflet)
const mapSelector = '#navitimeMap'
up.compiler(mapSelector, function (element, data) {
  initMap(data)
  ensureLeafletMap()
})

// Map loading animation
up.on('app:map-loaded', function () {
  $('#map-loading').slideUp()
})

// Handle fragment inserted: clear any Bootstrap popovers and animate
function removeIfAnyPopover() {
  if (window.currentPopover) {
    window.currentPopover.dispose()
    window.currentPopover = null
  }
}
up.on('up:fragment:inserted', (event, fragment) => {
  removeIfAnyPopover()
  fragment.classList.add('new-fragment', 'inserted')
  up.util.timer(0, () => fragment.classList.remove('inserted'))
  up.util.timer(1000, () => fragment.classList.remove('new-fragment'))
})

// SPA-like reload helper (preserved)
window.reload = () => {
  // up.reload({ target: 'body', url: window.location.href })
  window.location.reload()
}

// Alpine component factory (preserve global assignment used by templates)
window.tripDataAlpine = tripDataAlpine

// Driving report dashboard (clock + vehicle position map) and report detail (routes + timetable)
registerDrivingDashboard()
registerDrivingReportDetail()

// Register shared UI compilers
registerUICompilers()
registerToastCompiler()
registerCardWidgetCompiler()
